var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssouflement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 16.3335C10.8778 16.4919 11.1237 16.5979 11.3839 16.6427C11.6442 16.6875 11.9114 16.6698 12.1634 16.591C12.4155 16.5123 12.6453 16.3748 12.8338 16.1898C13.0223 16.0048 13.1641 15.7777 13.2476 15.5272C13.3312 15.2767 13.3539 15.0099 13.3141 14.7488C13.2743 14.4877 13.173 14.2399 13.0186 14.0256C12.8642 13.8114 12.661 13.6369 12.426 13.5166C12.1909 13.3963 11.9306 13.3335 11.6665 13.3335H1.6665",
    stroke: "#5E4DE6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 6.66683C14.7962 6.38274 15.0784 6.15782 15.4028 6.01345C15.7273 5.86907 16.0832 5.81002 16.4369 5.84191C16.7906 5.87381 17.1303 5.99558 17.4237 6.19566C17.717 6.39575 17.9544 6.66751 18.1132 6.98513C18.272 7.30276 18.347 7.65571 18.3311 8.01047C18.3151 8.36523 18.2087 8.71002 18.022 9.0121C17.8353 9.31418 17.5745 9.56353 17.2643 9.73646C16.9542 9.90939 16.605 10.0002 16.2498 10.0002H1.6665",
    stroke: "#5E4DE6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 3.66683C8.37777 3.50838 8.62367 3.4024 8.88393 3.35762C9.1442 3.31285 9.41138 3.33056 9.66345 3.40931C9.91552 3.48805 10.1453 3.62556 10.3338 3.81052C10.5223 3.99548 10.6641 4.22258 10.7476 4.47312C10.8312 4.72365 10.8539 4.99044 10.8141 5.25151C10.7743 5.51258 10.673 5.76044 10.5186 5.97468C10.3642 6.18892 10.161 6.3634 9.92597 6.48374C9.6909 6.60407 9.43059 6.66683 9.1665 6.66683H1.6665",
    stroke: "#5E4DE6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssouflement);
export default __webpack_public_path__ + "static/media/essouflement.4b5b63bfab436dd01f9129f8c1d329b5.svg";
export { ForwardRef as ReactComponent };